<section class="w-100 h-12">
    <nav class="navBar">
        <div class="d-flex align-items-center flex-30">
            <button class="btn-bar">
                <object data="assets/agview-connect/Bars.svg" type="image/svg+xml">
                    {{ "COMPONENTS.AGVIEW_CONNECT.NAVBAR_PRINCIPAL.SETTINGS" | transloco }}
                </object>
            </button>
            <img class="premoplan-logo" src="assets/imagens/logo-branca-completa.png" alt="logo-premoplan">
        </div>
        <div class="d-flex gap-2 justify-content-center align-items-center flex-40">
            <button class="btn-nav btn-navconfig">
                <object data="assets/agview-connect/fan.svg" type="image/svg+xml">
                    {{ "COMPONENTS.AGVIEW_CONNECT.NAVBAR_PRINCIPAL.FAN" | transloco }}
                </object>
            </button>
            <button class="btn-nav btn-navconfig">
                <object data="assets/agview-connect/warning.svg" type="image/svg+xml">
                    {{ "COMPONENTS.AGVIEW_CONNECT.NAVBAR_PRINCIPAL.WARNING" | transloco }}
                </object>
            </button>
            <button class="btn-nav btn-navconfig">
                <object data="assets/agview-connect/moon.svg" type="image/svg+xml">
                    {{ "COMPONENTS.AGVIEW_CONNECT.NAVBAR_PRINCIPAL.THEME" | transloco }}
                </object>
            </button>
            <button class="btn-nav btn-navconfig">
                <object data="assets/agview-connect/point.svg" type="image/svg+xml">
                    {{ "COMPONENTS.AGVIEW_CONNECT.NAVBAR_PRINCIPAL.LOCATION" | transloco }}
                </object>
            </button>
            <button class="btn-nav btn-navconfig">
                <object data="assets/agview-connect/light.svg" type="image/svg+xml">
                    {{ "COMPONENTS.AGVIEW_CONNECT.NAVBAR_PRINCIPAL.LIGHT" | transloco }}
                </object>
            </button>
        </div>
        <div class="d-flex justify-content-end align-items-center gap-2 flex-30">
            <div class="d-flex flex-column justify-content-center gap-1">
                <div class="d-flex justify-content-center gap-2">
                    <object class="user-svg" data="assets/agview-connect/user.svg" type="image/svg+xml">
                        {{ "COMPONENTS.AGVIEW_CONNECT.NAVBAR_PRINCIPAL.USER" | transloco }}
                    </object>
                    <span>{{ nomeUsuario }}</span>
                </div>
                <div class="d-flex justify-content-end gap-2">
                    <span>15:32</span>
                    <span>02/12/2024</span>
                </div>
            </div>
            <button class="btn-nav btn-configs">
                <object data="assets/agview-connect/gear.svg" type="image/svg+xml">
                    {{ "COMPONENTS.AGVIEW_CONNECT.NAVBAR_PRINCIPAL.SETTINGS" | transloco }}
                </object>
            </button>
        </div>
    </nav>
</section>